module.exports = __webpack_public_path__ + "static/media/intro.3f7813c7.mp3";